<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="borderTypeUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="borderTypes"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-border-type
      :borderType="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-border-type
      :key="borderTypeUpdateKey"
      :borderType="selectedBorderType"
      :visible="dialogType === 'update'"
      :id="selectedBorderType.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-border-type
      :visible="dialogType === 'delete'"
      :borderType="selectedBorderType"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-border-type>
  </div>
</template>

<script>
import CreateBorderType from "./CreateBorderType";
import UpdateBorderType from "./UpdateBorderType";
import DeleteBorderType from "./DeleteBorderType";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateBorderType,
    UpdateBorderType,
    DeleteBorderType,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      borderTypeUpdateKey: null,
      borderTypeList: [],
      isLoading: false,
      dialogType: "",
      selectedBorderType: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "borderTypes"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    console.log("BorderTypeList mounted");

    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchBorderTypes", "createBorderType", "updateBorderType"]),
    editBorderType(borderType) {
      this.selectedBorderType = { ...borderType };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, borderType) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedBorderType = { ...borderType };
      }
    },
    openDeleteModal(type, borderType) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedBorderType = { ...borderType };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedBorderType = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedBorderType = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createBorderType(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateBorderType(item);
      this.borderTypeUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchBorderTypes()
        .then((response) => {
          console.log("Data fetched successfully:", response.data);
          this.borderTypes = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
